import { render, staticRenderFns } from "./sortOncallMemberModal.vue?vue&type=template&id=64131e7c&"
import script from "./sortOncallMemberModal.vue?vue&type=script&lang=ts&"
export * from "./sortOncallMemberModal.vue?vue&type=script&lang=ts&"
import style0 from "./sortOncallMemberModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports